module.exports = __webpack_public_path__ + "static/Tomasz_Lakomy-ff70a6c14eaeb32538a3288d4ba44543.jpg";